import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des formats d'articles
 */
const articleFormatsConfig = {
  entityName: 'article_formats',
  apiEndpoint: '/api/config/tool/article-formats',
  exportFileName: 'article_formats',
  
  translations: {
    title: 'ARTICLE_FORMATS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { 
      key: 'usage_type', 
      label: 'Type d\'usage', 
      labelKey: 'TABLE_USAGE_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'usage_type'
    },
    { key: 'search_pattern', label: 'Pattern de recherche', labelKey: 'TABLE_SEARCH_PATTERN' },
    { key: 'replace_pattern', label: 'Pattern de remplacement', labelKey: 'TABLE_REPLACE_PATTERN' },
    { key: 'rule_order', label: 'Ordre', labelKey: 'TABLE_RULE_ORDER' },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  formFields: [
    {
      name: 'usage_type',
      label: 'Type d\'usage',
      labelKey: 'FORM_USAGE_TYPE',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'usage_type'
    },
    {
      name: 'search_pattern',
      label: 'Pattern de recherche',
      labelKey: 'FORM_SEARCH_PATTERN',
      type: 'textarea',
      required: true,
      placeholder: 'Pattern regex ou texte à rechercher'
    },
    {
      name: 'replace_pattern',
      label: 'Pattern de remplacement',
      labelKey: 'FORM_REPLACE_PATTERN',
      type: 'textarea',
      required: true,
      placeholder: 'Texte ou pattern de remplacement'
    },
    {
      name: 'rule_order',
      label: 'Ordre de la règle',
      labelKey: 'FORM_RULE_ORDER',
      type: 'number',
      required: false,
      placeholder: 'Ordre d\'application (optionnel)'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'FORM_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'usage_type',
      label: 'Type d\'usage',
      labelKey: 'FILTER_USAGE_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'usage_type'
    },
    {
      name: 'search_pattern',
      label: 'Pattern de recherche',
      labelKey: 'FILTER_SEARCH_PATTERN',
      type: 'text',
      placeholder: 'Filtrer par pattern de recherche...'
    },
    {
      name: 'replace_pattern',
      label: 'Pattern de remplacement',
      labelKey: 'FILTER_REPLACE_PATTERN',
      type: 'text',
      placeholder: 'Filtrer par pattern de remplacement...'
    },
    {
      name: 'is_active',
      label: 'Statut',
      labelKey: 'FILTER_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    usage_type: '',
    search_pattern: '',
    replace_pattern: '',
    rule_order: '',
    is_active: true
  }
};

/**
 * Composant d'administration des formats d'articles
 */
export default function AdminArticleFormatsTab() {
  return (
    <AdminDataTable {...articleFormatsConfig} />
  );
}
